import styled, { css } from "styled-components";

import { colorsPalettes, setFontVariant } from "@similarweb/styles";
import { EmptyState } from "@similarweb/ui-components";
import { Flex, Stack } from "@similarweb/ui-components/foundations";

import { WidgetContainer } from "app/components/React/WidgetContainer/WidgetContainer";
import { FlexRow, RightFlexRow } from "pro-features/styled components/StyledFlex/src/StyledFlex";

export const MEDIUM_SCREEN_BREAKPOINT = "1315px";

export const StyledBanner = styled(Flex)<{ $isCompareMode?: boolean }>`
    background-color: ${colorsPalettes.bluegrey[200]};
    padding: 0 16px;
    ${({ $isCompareMode }) => $isCompareMode && "margin: 0 12px 4px 24px;"}
    border-radius: 3px;
    ${setFontVariant("body1", colorsPalettes.carbon[400])};
    height: 48px;
    ${({ $isCompareMode }) => !$isCompareMode && "width: 100%;"}
`;

export const BreakdownChartContainer = styled(Flex)`
    padding: 14px 24px 24px 24px;
    height: 100%;
    flex-direction: column;
    justify-content: center;

    @media (max-width: ${MEDIUM_SCREEN_BREAKPOINT}) {
        padding-top: 24px;
        justify-content: flex-start;
    }
`;

export const BreakdownChartWithLegendContainer = styled(Flex)`
    flex-direction: row;
    align-items: flex-start;
    justify-content: space-between;
    gap: 24px;
    width: 100%;

    @media (max-width: ${MEDIUM_SCREEN_BREAKPOINT}) {
        flex-direction: column;
        align-items: center;
        justify-content: center;
    }
`;

export const BreakdownLegendWrapper = styled(Flex)`
    flex: 0 1 196px;
    min-width: 140px;
    justify-content: flex-end;

    @media (max-width: ${MEDIUM_SCREEN_BREAKPOINT}) {
        width: 100%;
        flex: 1;
        min-width: 0;
        justify-content: center;
    }
`;

export const BreakdownChartWrapper = styled(Flex)`
    justify-content: center;
    flex: 1 1 auto;
    min-width: 0;

    @media (max-width: ${MEDIUM_SCREEN_BREAKPOINT}) {
        flex: 0 0 auto;
    }
`;

export const DevicesTitles = styled(FlexRow)`
    justify-content: space-between;
    margin-bottom: 12px;
    ${setFontVariant("captionTitle", colorsPalettes.carbon[300])}
`;

export const TableFooter = styled(RightFlexRow)`
    padding: 8px 16px;
`;

export const GraphLegendWrapper = styled.span`
    margin-right: 40px;
    > div {
        > div {
            width: 100%;
        }
        > label {
            padding-left: 16px;
            overflow: visible;
        }
    }
`;

export const WidgetContainerWithMarginBottom = styled(WidgetContainer)`
    margin-bottom: 24px;
`;

export const GraphContainer = styled.div`
    padding: 24px;
`;

export const CompareGraphContainer = styled.div`
    padding: 32px 24px 24px 24px;
    position: relative;
`;

export const EmptyStateStyled = styled(EmptyState)<{ $gridSpan: number; $minHeight?: number }>`
    ${({ $minHeight = 134 }) => css`
        min-height: ${$minHeight}px;
    `}

    ${({ $gridSpan }) =>
        $gridSpan &&
        css`
            grid-column: span ${$gridSpan};
        `}
`;

export const ConditionalSideBySideContainer = styled.div`
    display: grid;
    column-gap: 24px;
    grid-template-columns: repeat(2, minmax(0, 1fr));

    @media (max-width: 1800px) {
        grid-template-columns: minmax(0, 1fr);
    }
`;

export const BlurContainer = styled.div<{ $active: boolean }>`
    ${({ $active }) =>
        $active &&
        css`
            .blurable-cell,
            .blurable-cell .swTable-progressBar {
                filter: blur(6px) opacity(0.85);
                user-select: none;
                pointer-events: none;

                &.no-data {
                    filter: blur(4px);
                }
            }
        `}
`;

export const CompareTableWrapper = styled(Stack)`
    height: 100%;
`;
